import { useMutation } from 'react-query'

import { createCheckIn, createTanningCheckIn } from '@services/check-in/check-in.service'
import { trackEvent } from '_services/posthog'

export const useInitiateCheckIn = (options) => {
  return useMutation(createCheckIn, {
    ...options,
    onSuccess: (data, variables, context) => {
      trackEvent('checkin.processed', {
        method: 'manual',
        client_id: variables?.clientId,
        site_id: variables?.siteId,
      })
      options?.onSuccess?.(data, variables, context)
    },
  })
}

export const useInitiateTanningCheckIn = (options) => {
  return useMutation(createTanningCheckIn, {
    ...options,
    onSuccess: (data, variables, context) => {
      trackEvent('checkin.processed', {
        method: 'tanning',
        client_id: variables?.clientId,
        site_id: variables?.siteId,
      })
      options?.onSuccess?.(data, variables, context)
    },
  })
}
